import React, { useState } from "react";
import { useSelector } from "react-redux";
import { SearchesCIcon, CancelIcon } from "../../../assets/SvgIcons";
import CreateProjectModal from "../Modal/projectModal";
import ConfirmBox from "../Modal/ConfirmBox";
import NoDataFound from "../../../NoDataFound";
import apiClient from "../../../apiClient/index.js";
import { CLONE_PROJECT, MOVE_TO_TRASH } from "../../../apiClient/apiEndpoints.js";
import ShareProject from "../Modal/ShareProject.js";
import ProjectCard from "./ProjectCard.js";
import ProjectLoadCard from "./ProjectLoadCard.js";

const ProjectList = ({ list, listLoading, getProjectList, showDashboard, trashProjectList, usersList }) => {
  const configData = useSelector((state) => state.configSlice);
  const [createModal, setCreateModal] = useState(false);
  const closeCreateModal = () => setCreateModal(false);
  const openCreateModal = () => setCreateModal(true);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [actionProjectId, setActionProjectId] = useState(null);
  const [modelType, setModelType] = useState(null);
  const [title, setTitle] = useState(null);
  const [message, setMessage] = useState(null);
  const [shareProject, setShareProject] = useState({
    id: null,
    name: null,
  });

  const confirmMoveToTrash = (e, type) => {
    setActionProjectId(e);
    setShow(true);
    setModelType(type);
    if (type === "TRASH") {
      setTitle("Move to trash");
      setMessage("Do you really want to move this project to the trash?");
    } else if (type === "CLONE") {
      setTitle("Make a clone");
      setMessage("Do you really want to clone this project?");
    }
  };

  const cloneProject = async () => {
    await apiClient.get(`${configData.config.API_URL}${CLONE_PROJECT}/${actionProjectId}`);
    closeModal();
    getProjectList();
    trashProjectList();
  };

  const handleMoveToTrash = async () => {
    await apiClient.get(`${configData.config.API_URL}${MOVE_TO_TRASH}/${actionProjectId}`);
    closeModal();
    getProjectList();
    trashProjectList();
  };

  const handleConfirm = async () => {
    if (modelType === "TRASH") {
      await handleMoveToTrash();
    } else if (modelType === "CLONE") {
      await cloneProject();
    }
  };

  const closeModal = () => {
    setShow(false);
    setActionProjectId(null);
    setModelType(null);
    setTitle(null);
    setMessage(null);
  };

  const handleEnableShareProject = (data) => {
    setShareProject({
      id: data.uuid,
      name: data.name,
    });
    setShowShareModal(true);
  };

  return (
    <>
      {!showDashboard && (
        <div className="row pt-3 mb-3 ps-0">
          <div className="col-md-6">
            <form className=" app-search app-search1 d-flex justify-content-start ">
              <div className="position-relative">
                <SearchesCIcon />
                {search.length > 0 && (
                  <span className="searchiconcancel" onClick={() => setSearch("")}>
                    <CancelIcon />
                  </span>
                )}
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  name="searchName"
                  className="form-control"
                  placeholder="Search"
                  autoComplete="off"
                />
              </div>
            </form>
          </div>
          <div className="col-md-6 d-flex align-items-center justify-content-end">
            <button className="redstandardbtn" onClick={openCreateModal}>
              New Project
            </button>
          </div>
        </div>
      )}

      {listLoading ? (
        <div className="main-list">
          {Array.from({ length: 5 }).map((_, index) => (
            <ProjectLoadCard key={index} />
          ))}
        </div>
      ) : (
        <>
          {list.length > 0 ? (
            <div className="main-list">
              {list.map((e) => {
                if (search.length && !e.name.toLowerCase().includes(search)) return null;
                return (
                  <ProjectCard
                    key={e.uuid}
                    projectData={e}
                    showDashboard={showDashboard}
                    handleEnableShareProject={handleEnableShareProject}
                    confirmMoveToTrash={confirmMoveToTrash}
                  />
                );
              })}
            </div>
          ) : (
            <NoDataFound heading={"No Projects Found "} />
          )}
        </>
      )}

      {showShareModal && (
        <ShareProject
          showShareModal={showShareModal}
          closeShareProjectModal={() => setShowShareModal(false)}
          usersList={usersList}
          shareProject={shareProject}
        />
      )}
      <CreateProjectModal
        createModal={createModal}
        closeCreateModal={closeCreateModal}
        getProjectList={getProjectList}
      />
      <ConfirmBox title={title} message={message} show={show} setShow={closeModal} handleConfirm={handleConfirm} />
    </>
  );
};

export default ProjectList;
